<template>
  <div class="error-feedback">
    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
      <circle cx="7" cy="7" r="6.5" fill="white" stroke="#FF238D"></circle>
      <circle cx="7" cy="10" r="1" fill="#FF238D"></circle>
      <rect x="6" y="3" width="2" height="5" rx="1" fill="#FF238D"></rect>
    </svg>
    <div class="error-feedback__text">
      {{ text }}
    </div>
  </div>
</template>

<script>
export default {
  props: ["text"],
};
</script>

<style lang="scss" scoped>
.error-feedback {
  display: flex;
  align-items: center;
  margin-top: 8px;

  &__text {
    font-size: 11px;
    color: #ff238d;
    margin-left: 6px;
    margin-top: 1px;
    line-height: 1;
  }

  svg {
    flex-shrink: 0;
  }
}
</style>
